/* Watcheski Atelier v2 — vanilla JS, no paid app dependencies */
(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let toastTimer, drawerTrigger;

  function toast(message) {
    const node = $('#WatcheskiToast'); if (!node) return;
    node.textContent = message; node.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => node.classList.remove('is-visible'), 3700);
  }
  function money(minor, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency || 'GBP' }).format(minor / 100); }
    catch { return (minor / 100).toFixed(2); }
  }
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(node => { node.textContent = count; node.hidden = !count; });
  }

  function initHeader() {
    const nav = $('#WatcheskiMobileNav'), toggle = $('[data-menu-toggle]');
    if (toggle && nav) toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
    const panel = $('#WatcheskiSearch'), searchButton = $('[data-search-toggle]');
    if (searchButton && panel) searchButton.addEventListener('click', () => {
      const open = panel.classList.toggle('is-open'); searchButton.setAttribute('aria-expanded', String(open));
      if (open) $('input[name=q]', panel)?.focus();
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      nav?.classList.remove('is-open'); panel?.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      toggle?.setAttribute('aria-expanded', 'false'); searchButton?.setAttribute('aria-expanded', 'false');
    });
  }

  function cartDrawer() {
    const drawer = $('#WatcheskiCartDrawer'), backdrop = $('[data-cart-drawer-backdrop]');
    if (!drawer || !backdrop) return null;
    function close() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true; document.body.classList.remove('drawer-open');
      drawerTrigger?.focus();
    }
    function open() {
      drawerTrigger = document.activeElement;
      backdrop.hidden = false; drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false'); document.body.classList.add('drawer-open');
      $('[data-cart-drawer-close]', drawer)?.focus();
    }
    async function refresh() {
      const response = await fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw Error('Could not load the bag');
      const cart = await response.json(); updateCartCount(cart.item_count);
      const list = $('[data-cart-drawer-items]', drawer); if (!list) return;
      list.replaceChildren();
      if (!cart.items.length) { const p = document.createElement('p'); p.className = 'muted'; p.textContent = 'Your bag is empty.'; list.appendChild(p); }
      for (const item of cart.items) {
        const row = document.createElement('div'); row.className = 'cart-drawer__item';
        if (item.image && /^(https?:)?\/\/|^\//.test(item.image)) {
          const img = document.createElement('img'); img.src = item.image; img.alt = item.product_title; img.loading = 'lazy'; row.appendChild(img);
        }
        const info = document.createElement('div');
        const title = document.createElement('a'); title.href = item.url; title.textContent = item.product_title; title.className = 'cart-drawer__item-title'; info.appendChild(title);
        if (item.variant_title && item.variant_title !== 'Default Title') { const variant = document.createElement('p'); variant.className = 'muted'; variant.textContent = item.variant_title; info.appendChild(variant); }
        const meta = document.createElement('p'); meta.textContent = `Qty ${item.quantity} · ${money(item.final_line_price, cart.currency)}`; info.appendChild(meta);
        row.appendChild(info); list.appendChild(row);
      }
      $('[data-drawer-count]', drawer).textContent = '(' + cart.item_count + ')';
      $('[data-cart-drawer-subtotal]', drawer).textContent = money(cart.total_price, cart.currency);
    }
    $('[data-cart-drawer-close]', drawer)?.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) { e.preventDefault(); close(); }
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        const focusable = $$('button:not([disabled]),a[href]', drawer).filter(el => el.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    $$('[data-cart-trigger]').forEach(link => link.addEventListener('click', async e => {
      if (e.ctrlKey || e.metaKey || e.shiftKey) return;
      e.preventDefault(); open();
      try { await refresh(); } catch { window.location.href = link.href; }
    }));
    return { open, refresh };
  }

  function initProduct(drawer) {
    $$('.watcheski-product').forEach(root => {
      const form = $('form.product-buy-form', root); if (!form) return;
      const select = $('[data-variant-select]', form), add = $('[data-add-to-cart]', form);
      const price = $('[data-product-price]', root), sticky = $('[data-sticky-add]', root), stickyPrice = $('[data-sticky-price]', root);
      const updateVariant = () => {
        const option = select?.selectedOptions[0]; if (!option) return;
        const available = option.dataset.available === 'true';
        add.disabled = !available; add.textContent = available ? 'Add to bag \u2197\uFE0E' : 'Sold out';
        if (sticky) { sticky.disabled = !available; sticky.textContent = available ? 'Add to bag \u2197\uFE0E' : 'Sold out'; }
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
        const u = new URL(window.location.href); u.searchParams.set('variant', select.value); history.replaceState({}, '', u);
      };
      select?.addEventListener('change', updateVariant);
      const bar = $('[data-mobile-buy-bar]', root);
      if (bar && add && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          // Reveal sticky purchase button only when main button has scrolled above viewport.
          const entry = entries[0]; bar.classList.toggle('is-active', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0 });
        observer.observe(add);
      }
      form.addEventListener('submit', async e => {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault(); add.disabled = true; if (sticky) sticky.disabled = true; add.classList.add('loading');
        try {
          const response = await fetch(routeRoot + 'cart/add.js', {
            method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
          });
          const data = await response.json(); if (!response.ok) throw new Error(data.description || 'Unable to add this watch.');
          if (drawer) { drawer.open(); await drawer.refresh(); }
          else window.location.href = routeRoot + 'cart';
        } catch (err) { toast(err.message || 'Please try again.'); }
        finally {
          add.classList.remove('loading');
          const selectedAvailable = select ? select.selectedOptions[0]?.dataset.available === 'true' : true;
          add.disabled = !selectedAvailable; if (sticky) sticky.disabled = !selectedAvailable;
        }
      });
    });
    const zoom = $('#WatcheskiGalleryZoom');
    if (zoom) {
      let originalFocus = null;
      const close = () => { zoom.classList.remove('is-open'); zoom.setAttribute('aria-hidden','true'); originalFocus?.focus(); };
      $$('[data-gallery-src]').forEach(el => el.addEventListener('click', () => {
        originalFocus = el; $('img', zoom).src = el.dataset.gallerySrc;
        zoom.classList.add('is-open'); zoom.setAttribute('aria-hidden','false');
        $('button',zoom)?.focus();
      }));
      zoom.addEventListener('click', e => { if (e.target === zoom || e.target.closest('button')) close(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && zoom.classList.contains('is-open')) close(); });
    }
  }

  function initRelated() {
    $$('[data-related-watches]').forEach(async node => {
      const productId = node.dataset.productId, sectionId = node.dataset.sectionId;
      if (!productId || !sectionId) return;
      try {
        const url = routeRoot + 'recommendations/products?product_id=' + encodeURIComponent(productId) + '&section_id=' + encodeURIComponent(sectionId) + '&limit=4&intent=related';
        const response = await fetch(url); if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const from = html.querySelector('[data-related-watches]');
        if (from && from.querySelector('.product-card')) { node.innerHTML = from.innerHTML; node.hidden = false; }
      } catch { /* No recommendations is not an error. */ }
    });
  }

  function initCollection() {
    $$('[data-sort-by]').forEach(select => select.addEventListener('change', () => {
      const u = new URL(location.href); u.searchParams.set('sort_by', select.value); u.searchParams.delete('page'); location.href = u.toString();
    }));
    const btn = $('[data-mobile-filter-toggle]'), panel = $('#WatcheskiFilters');
    if (btn && panel) btn.addEventListener('click', () => { const opened = panel.classList.toggle('is-open'); btn.setAttribute('aria-expanded', String(opened)); btn.textContent = opened ? 'Close filters −' : 'Filters +'; });
  }
  function initCartPage() {
    $$('[data-quantity-minus], [data-quantity-plus]').forEach(btn => btn.addEventListener('click', () => {
      const root = btn.closest('[data-cart-line]'); if (!root) return;
      const input = $('input[name="updates[]"]', root); if (!input) return;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + (btn.hasAttribute('data-quantity-plus') ? 1 : -1));
      input.closest('form')?.submit();
    }));
    $$('input[name="updates[]"]').forEach(input => input.addEventListener('change', () => input.closest('form')?.submit()));
  }
  function boot() { initHeader(); const drawer = cartDrawer(); initProduct(drawer); initRelated(); initCollection(); initCartPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
